import React, { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { useParams } from 'react-router-dom'

import {
  Loading,
  SpacingVertical,
  SPACING_24,
  ToastContainer
} from 'mailup-web-components'
import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import ModalConfirmReset from './components/ModalConfirmReset'
import Header from './components/Header'
import PageContainer from 'Components/PageContainer'
import Description from './components/Description'
import Footer from './components/Footer'
import InputPlainText from './components/InputPlainText'
import ModalConfirmLeave from 'Components/ModalConfirmLeave/ModalConfirmLeave'

import { pageState } from './recoil/state/page'
import { messageState } from './recoil/state/message'
import { cleanupCallback, initCallback } from './recoil/callbacks/callbacks'
import ModalCreateTextVersion from './components/ModalCreateTextVersion'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'

const TextVersion = () => {
  const { id } = useParams()

  const { loading, loaded, error, severity } = useRecoilValue(pageState)
  const { isDirty } = useRecoilValue(messageState)

  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(cleanupCallback, [])
  useBeforeUnload(isDirty)
  useEffect(() => {
    init(+id || 0)

    return cleanup()
  }, [])

  return (
    <>
      <ToastContainer />
      <Loading open={loading} />
      <ModalConfirmReset />
      <ModalCreateTextVersion />
      <ModalConfirmLeave isDirty={isDirty} />
      <Header />
      <PageContainer>
        {error && (
          <ErrorFeedback
            error={error}
            severity={severity}
            onClickReload={() => init(+id || 0)}
          />
        )}
        {!error && loaded && (
          <>
            <Description />
            <SpacingVertical variant={SPACING_24} />
            <InputPlainText />
            <Footer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default TextVersion
